import { Button, InputFieldCompact } from '@swegon-core/uic';
import { Print as PrintIcon } from '@swegon-core/uic/dist/src/theme/icons';
import {
    PrintButtonContainer,
    PrintContainer,
    PrintOptionContainer
} from './Print.styles';
import {
    addListenersIfOngoingPrintJob,
    getPrintDocumentCallback
} from './Print.functions';
import EventStore from '../shared/components/websocket/eventStore';
import { User } from '../shared/authentication/User.types';
import { useContext, useEffect, useState } from 'react';
import { SelectFieldOption } from '@swegon-core/uic/dist/src/components/forms/types';
import { Context as TranslationContext } from '../shared/contexts/TranslationContext';
import { BackendApiContext } from '../shared/contexts/BackendApiContext';

export interface PrintProps {
    eventStore: EventStore | undefined;
    user: User;
    market: string;
    airflowUnit: string;
    calculationJobId: string | null;
    printButtonDisabled: boolean;
    productVariant: string;
}

const Print = ({
    eventStore,
    user,
    market,
    airflowUnit,
    calculationJobId,
    printButtonDisabled,
    productVariant
}: PrintProps) => {
    const printOptions: SelectFieldOption[] = [
        { title: 'PDF', value: 'PDF' },
        { title: 'DXF', value: 'DXF' }
    ];
    const { l } = useContext(TranslationContext);
    const { backendApi } = useContext(BackendApiContext);
    const [activePrintOption, setActivePrintOption] = useState<string>(
        printOptions[0].value
    );
    const [printIsLoading, setPrintIsLoading] = useState<boolean>(false);

    const onPrintIsLoading = (loading: boolean) => {
        setPrintIsLoading(loading);
    };

    useEffect(() => {
        addListenersIfOngoingPrintJob(
            backendApi,
            eventStore,
            calculationJobId,
            user,
            productVariant,
            onPrintIsLoading
        );
        // We want this effect to only run once
        // Note that it will run twice in dev mode since
        // all renders and effects are run twice when Strict
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <PrintContainer>
            <PrintOptionContainer>
                <InputFieldCompact
                    id="print-option"
                    aria-label={l('print.documentFormat')}
                    type={'select'}
                    options={printOptions}
                    value={activePrintOption}
                    onChange={(printOption) =>
                        setActivePrintOption(printOption)
                    }
                />
            </PrintOptionContainer>
            <PrintButtonContainer
                title={
                    printButtonDisabled
                        ? l('ahuDesignLite.customizeInAHUDesignTooltip')
                        : undefined
                }
            >
                <Button
                    id={'print-button'}
                    label={l('navigation.print')}
                    aria-label={l('navigation.print')}
                    onClick={() =>
                        getPrintDocumentCallback(
                            backendApi,
                            eventStore,
                            activePrintOption,
                            onPrintIsLoading,
                            user,
                            market,
                            airflowUnit,
                            productVariant
                        )
                    }
                    disabled={printButtonDisabled}
                    icon={PrintIcon}
                    showSpinnerOnClick={printIsLoading}
                />
            </PrintButtonContainer>
        </PrintContainer>
    );
};

export default Print;
